import { TypeManagerDecorator } from "../../main/type.map.service";
import { ColumnValue } from "./calendaring.util";
import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { EventProfileReservation } from "../../pojo/EventI";

@TypeManagerDecorator("s25-ng-calendar-column-value")
@Component({
    selector: "s25-ng-calendar-column-value",
    template: `
        @if (columnValue?.type === "text") {
            {{ columnValue.value }}
        } @else if (columnValue?.type === "link") {
            <a [href]="columnValue.value">{{ columnValue.value }}</a>
        } @else if (columnValue?.type === "eventDetails") {
            <a href="javascript:void(0)" (click)="switchToEventDetails?.(reservation)">{{ columnValue.value }}</a>
        } @else if (columnValue?.type === "component") {
            <s25-ng-dynamic-content [dynamicValue]="columnValue"></s25-ng-dynamic-content>
        }
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class CalendarColumnValue {
    @Input() columnValue: ColumnValue;
    @Input() reservation: EventProfileReservation;
    @Input() switchToEventDetails?: (reservation: EventProfileReservation) => void;
}
